import withLazy from '~reviews/Widget/hoc/with-lazy';

export default withLazy({
  importFn: () => import(/* webpackChunkName: "wr-reply-box" */ './reply-box'),
  errorHandling: { type: 'PROPAGATE' },
});
